import { FIFTEEN_MINUTES } from '@avanta/shared/constants/common';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { QUERY_KEYS } from 'constants/common';
import { AppointmentService } from 'services/appointments';
import { useUserStore } from 'stores/user';
import { type Center, type AppointmentHistoricalPsychoDTO } from 'types/appointments';

export type AppointmentHistoricalPsychoWithCenter = AppointmentHistoricalPsychoDTO & {
  center?: Center;
};

export const useFetchPsychologistHistoricalPatients = (): UseQueryResult<
  AppointmentHistoricalPsychoWithCenter[],
  Error
> => {
  const psychologistId = useUserStore(state => state.user?.id) ?? '';
  return useQuery({
    queryKey: [QUERY_KEYS.FETCH_PSYCHOLOGIST_HISTORICAL_PATIENTS, psychologistId],
    queryFn: async () => {
      const { data: patients } =
        await AppointmentService.getPsychologistHistoricalPatients(psychologistId);
      const filteredPatients = patients.filter(p => !p.patient.banned);

      if (filteredPatients.length === 0) return [];

      return Promise.all(
        filteredPatients.map(async patient => ({
          ...patient,
          center: (await AppointmentService.getCenterDetails(patient.centerId)).data,
        }))
      );
    },
    placeholderData: previousData => previousData,
    enabled: !!psychologistId,
    staleTime: FIFTEEN_MINUTES,
  });
};
